import { isUndNullEmp } from '../../helpers/main.js';

export class StatementAccount {
    constructor(
        _cRifEmpresa = '',
        _cCodEmpresa = '',
        _cNomEmpresa = '',
        _tipo_Doc = '',
        _tipo_Doc_02 = '',
        _nro_Doc = 0,
        _reng_Num = 0,
        _numcon = '',
        _fec_emis = '',
        _fec_Venc = '',
        _campo1 = '',
        _campo2 = '',
        _campo3 = '',
        _campo4 = '',
        _campo5 = '',
        _campo6 = '',
        _campo7 = '',
        _campo8 = '',
        _nDiaPorVencer = 0,
        _nDiaVencido = 0,
        _observa = '',
        _co_Ven = '',
        _ven_Des = '',
        _monto_Net_Doc = 0,
        _saldo_Doc = 0,
        _monto_Net_Nde1 = 0,
        _monto_Net_Nde2 = 0,
        _saldo_Nde1 = 0,
        _saldo_Nde2 = 0,
        _co_Cli = '',
        _cli_Des = '',
        _respons = '',
        _email = '',
        _contribu_e = false,
        _total_Art = 0,
        _total_Art_Saldo = 0,
        _netAmountDocument = 0,
        _balanceDocument = 0,
        _netAmountDeliveryNote = 0,
        _balanceDeliveryNote = 0,
    ) {
        this.cRifEmpresa = _cRifEmpresa;
        this.cCodEmpresa = _cCodEmpresa;
        this.cNomEmpresa = _cNomEmpresa;
        this.tipo_Doc = _tipo_Doc;
        this.tipo_Doc_02 = _tipo_Doc_02;
        this.nro_Doc = _nro_Doc;
        this.reng_Num = _reng_Num;
        this.numcon = _numcon;
        this.fec_emis = _fec_Venc;
        this.fec_Venc = _fec_Venc;
        this.campo1 = _campo1;
        this.campo2 = _campo2;
        this.campo3 = _campo3;
        this.campo4 = _campo4;
        this.campo5 = _campo5;
        this.campo6 = _campo6;
        this.campo7 = _campo7;
        this.campo8 = _campo8;
        this.nDiaPorVencer = _nDiaPorVencer;
        this.nDiaVencido = _nDiaVencido;
        this.observa = _observa;
        this.co_Ven = _co_Ven;
        this.ven_Des = _ven_Des;
        this.monto_Net_Doc = _monto_Net_Doc;
        this.saldo_Doc = _saldo_Doc;
        this.monto_Net_Nde1 = _monto_Net_Nde1;
        this.monto_Net_Nde2 = _monto_Net_Nde2;
        this.saldo_Nde1 = _saldo_Nde1;
        this.saldo_Nde2 = _saldo_Nde2;
        this.co_Cli = _co_Cli;
        this.cli_Des = _cli_Des;
        this.respons = _respons;
        this.email = _email;
        this.contribu_e = _contribu_e;
        this.total_Art = _total_Art;
        this.total_Art_Saldo = _total_Art_Saldo;
        this.netAmountDocument = _netAmountDocument;
        this.balanceDocument = _balanceDocument;
        this.netAmountDeliveryNote = _netAmountDeliveryNote;
        this.balanceDeliveryNote = _balanceDeliveryNote;
    }

    static getClassName = () => {
        return 'StatementAccount - class';
    }

    //#region old code
    // static minMaxLength = (upperCase = false) => {
    //     if (upperCase) {
    //         return {
    //             min: {
    //                 CompanyId: 0,
    //                 CustomerId: 0,
    //             },
    //             max: {
    //                 CompanyId: 254,
    //                 CustomerId: 254,
    //             }
    //         };
    //     } else {
    //         return {
    //             min: {
    //                 companyId: 0,
    //                 customerId: 0,
    //             },
    //             max: {
    //                 companyId: 0,
    //                 customerId: 30,
    //             }
    //         };
    //     }
    // }
    //#endregion old code

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            if (upperCase) {
                return new StatementAccount(
                    obj.cRifEmpresa,
                    obj.cCodEmpresa,
                    obj.cNomEmpresa,
                    obj.TIPO_DOC,
                    obj.TIPO_DOC_02,
                    obj.NRO_DOC,
                    obj.RENG_NUM,
                    obj.NUMCON,
                    obj.FEC_EMIS,
                    obj.FEC_VENC,
                    obj.CAMPO1,
                    obj.CAMPO2,
                    obj.CAMPO3,
                    obj.CAMPO4,
                    obj.CAMPO5,
                    obj.CAMPO6,
                    obj.CAMPO7,
                    obj.CAMPO8,
                    obj.nDiaPorVencer,
                    obj.nDiaVencido,
                    obj.OBSERVA,
                    obj.CO_VEN,
                    obj.VEN_DES,
                    obj.MONTO_NET_DOC,
                    obj.SALDO_DOC,
                    obj.MONTO_NET_NDE1,
                    obj.MONTO_NET_NDE2,
                    obj.SALDO_NDE1,
                    obj.SALDO_NDE2,
                    obj.CO_CLI,
                    obj.CLI_DES,
                    obj.RESPONS,
                    obj.EMAIL,
                    obj.CONTRIBU_E,
                    obj.TOTAL_ART,
                    obj.TOTAL_ART_SALDO,
                    obj.NetAmountDocument,
                    obj.BalanceDocument,
                    obj.NetAmountDeliveryNote,
                    obj.BalanceDeliveryNote,
                );
            } else {
                return new StatementAccount(
                    obj.cRifEmpresa,
                    obj.cCodEmpresa,
                    obj.cNomEmpresa,
                    obj.tipo_Doc,
                    obj.tipo_Doc_02,
                    obj.nro_Doc,
                    obj.reng_Num,
                    obj.numcon,
                    obj.fec_emis,
                    obj.fec_Venc,
                    obj.campo1,
                    obj.campo2,
                    obj.campo3,
                    obj.campo4,
                    obj.campo5,
                    obj.campo6,
                    obj.campo7,
                    obj.campo8,
                    obj.nDiaPorVencer,
                    obj.nDiaVencido,
                    obj.observa,
                    obj.co_Ven,
                    obj.ven_Des,
                    obj.monto_Net_Doc,
                    obj.saldo_Doc,
                    obj.monto_Net_Nde1,
                    obj.monto_Net_Nde2,
                    obj.saldo_Nde1,
                    obj.saldo_Nde2,
                    obj.co_Cli,
                    obj.cli_Des,
                    obj.respons,
                    obj.email,
                    obj.contribu_e,
                    obj.total_Art,
                    obj.total_Art_Saldo,
                    obj.netAmountDocument,
                    obj.balanceDocument,
                    obj.netAmountDeliveryNote,
                    obj.balanceDeliveryNote,
                );
            }
        } else {
            return new StatementAccount();
        }
    }
}

//#region data example
// cRifEmpresa = 'J-40322711-0',
// cCodEmpresa = 'HCA_ADM',
// cNomEmpresa = 'HC Auto Accesorios  & GPS, C.A.',
// TIPO_DOC = 'FACT',
// TIPO_DOC_02 = '',
// NRO_DOC = 0,
// RENG_NUM = 0,
// NUMCON = '00-000256',
// FEC_EMIS = '',
// FEC_VENC = '',
// CAMPO1 = '',
// CAMPO2 = '',
// CAMPO3 = '',
// CAMPO4 = 'SER-DIS003,',
// CAMPO5 = '',
// CAMPO6 = '',
// CAMPO7 = '',
// CAMPO8 = '',
// nDiaPorVencer = 0,
// nDiaVencido = 2228,
// OBSERVA = '<RECONVERSION>Segùn Orden de servicio Nº = SER-DIS003',
// CO_VEN = 'CAHE',
// VEN_DES = 'T.S.U. - Ing. Carlos H.',
// MONTO_NET_DOC = 0,
// SALDO_DOC = 0,
// MONTO_NET_NDE1 = 0,
// MONTO_NET_NDE2 = 0,
// SALDO_NDE1 = 0,
// SALDO_NDE2 = 0,
// CO_CLI = '316779297',
// CLI_DES = 'DISOFI SERVICIOS 3548, C.A.',
// RESPONS = 'Ing. Junior Jaimes',
// EMAIL = 'junior.jaimes@disofi.com.ve',
// CONTRIBU_E = true,
// TOTAL_ART = 0,
// TOTAL_ART_SALDO = 0
//#endregion data example